<div mat-dialog-title class="ed-header">
    <div class="ed-header-main">
        <div class="ed-eyebrow">ECU Producer</div>
        <div class="ed-title">Add new ECU Producer</div>
    </div>
    <button type="button" class="ed-close" (click)="canceledOption()" aria-label="Close">
        <i class="bi bi-x-lg"></i>
    </button>
</div>

<mat-dialog-content class="ed-content ed-content--stack" [formGroup]="addNewEcuProducerForm" (keydown.enter)="saveNewRow()">
    <div class="ed-grid ed-grid--single">
        <div class="ed-field">
            <label class="ed-field-label">Correct Ecu Producer Names <span class="ed-req">*</span></label>
            <input class="ed-field-input" type="text" formControlName="correctEcuProducer"/>
            <div class="ed-field-error" *ngIf="addNewEcuProducerForm?.controls['correctEcuProducer'].hasError('required')">Please enter a correct Ecu Producer name.</div>
            <div class="ed-field-error" *ngIf="addNewEcuProducerForm?.controls['correctEcuProducer']?.hasError('ecuProducerExists')">Ecu Producer already exists in database.</div>
        </div>

        <div class="ed-field">
            <label class="ed-field-label">Accepted Ecu Producer Names <span class="ed-req">*</span></label>
            <input class="ed-field-input" type="text" formControlName="acceptedEcuProducer"/>
            <div class="ed-field-error" *ngIf="addNewEcuProducerForm.controls['acceptedEcuProducer'].hasError('required')">Please enter an accepted Ecu Producer.</div>
        </div>
    </div>
    <div class="ed-field-error" role="alert" *ngIf="saveError">{{ saveError }}</div>
</mat-dialog-content>

<div mat-dialog-actions class="ed-footer">
    <div class="ed-actions" style="margin-left:auto">
        <button type="button" class="ed-btn ed-btn-ghost" (click)="canceledOption()">Cancel</button>
        <button type="button" class="ed-btn ed-btn-primary" [disabled]="addNewEcuProducerForm.invalid || isSaving" (click)="saveNewRow()">
            <i class="bi bi-check-lg"></i>{{ isSaving ? 'Saving...' : 'Save' }}
        </button>
    </div>
</div>
